import { Action } from 'redux';

import { ICollectionInfo } from '../../../spaces/Collections/ICollectionInfo';
import { ChangeCollectionVisibility } from '../../AppActionTypes';

// TFS 1237812: Remove with CollectionsPermissions (collectionsPermissionsEnabled) feature flag
export interface ChangeCollectionVisibilityAction extends Action {
  targetItem: ICollectionInfo;
}

export function changeCollectionVisibility(targetItem: ICollectionInfo): ChangeCollectionVisibilityAction {
  return {
    type: ChangeCollectionVisibility,
    targetItem
  };
}
